@if (loading) {
  <div class="flex align-items-center justify-content-center">
    <patron-spinner color="primary" size="lg"></patron-spinner>
  </div>
}

@if (!initialized) {
  <div>Houve um erro ao inicializar</div>
}

@if (!loading && initialized) {
  <div>
    @if (!subscriber || !subscriber.id) {
      <div>
        <p>
          As notificações em segundo plano não foram ativadas neste dispositivo. Ative-as para
          recebê-las mesmo se a página não estiver aberta.
        </p>
        <patron-button (click)="activateNotifications()"
          >Ativar notificações em segundo plano</patron-button
        >
      </div>
    }
    @if (subscriber?.id) {
      <div>
        <p>
          As notificações em segundo plano estão ativas neste dispositivo
          <!-- <span *ngIf="subscriber!.created_at">desde {{ subscriber!.created_at | date: 'dd/MM/yyyy HH:mm:ss' }}</span> -->
        </p>
        <patron-button color="danger" (click)="deactivateNotifications()"
          >Desativar notificações em segundo plano</patron-button
        >
        @if (topics.length) {
          <patron-card header="Tópicos" styleClass="mt-3">
            @for (topic of topics; track topic) {
              <div>
                <patron-switch
                  [(ngModel)]="topic.active"
                  inline
                  [label]="topic.label!"
                  (handleChange)="topicsChanged(topic)">
                </patron-switch>
              </div>
            }
          </patron-card>
        }
      </div>
    }
  </div>
}
